<div class="sz-empty-state">
  <div class="sz-empty-state__glyph">
    <sz-icon [name]="icon()" [size]="32" />
  </div>
  <h3 class="sz-empty-state__title">{{ title() }}</h3>
  @if (description(); as desc) {
    <p class="sz-empty-state__desc">{{ desc }}</p>
  }
  <div class="sz-empty-state__cta">
    <ng-content />
  </div>
</div>
